// frontend/src/components/UserDashboard.js
import React from 'react';

export default function UserDashboard() {
  // Om du vill detektera Mac/Windows kan du använda navigator.userAgent
  return (
    <div className="app-wrapper">
      <h2>Välkommen till din dashboard</h2>
      <p>Ladda ned och kör din agent för att ansluta datorn.</p>
      {/* Byt URL nedan till din backend-subdomän, exempelvis api.example.com */}
      <a href="https://din-backend-subdomän.example.com/api/download-agent">
        <button>Ladda ned fjärragent</button>
      </a>
    </div>
  );
}
